export default function Step3() {
  return (
    <div className="flex size-full flex-col items-center overflow-hidden text-center">
      <div className="size-full max-h-[370px] overflow-hidden">
        <img
          alt="image"
          src="https://storage.googleapis.com/educabot-aec-cdn-1/tich/images/explanatory-modal/step-3.gif"
          className="block size-full max-h-full max-w-full overflow-hidden bg-transparent object-contain"
        />
      </div>
      <div className="w-full shrink-0 animate-fade-in overflow-hidden">
        <p className="mb-5 text-sm font-bold h-768:text-xl">
          La tarjeta que estabas por olvidar en el momento justo
        </p>
        <p className="text-sm font-normal h-768:text-xl">
          Cuando estés por olvidar una tarjeta, la sumaremos a este mazo especial
        </p>
        <p className="mt-5 rounded bg-orange-600 px-2 text-sm uppercase">
          100% de la información disponible para vos
        </p>
      </div>
    </div>
  )
}
